import Vue from 'vue';
import Vuex from 'vuex';
import VueCarousel from 'vue-carousel';
import App from './App.vue';
import SCSS from './assets/scss/screen.scss';
import jQueryUI from './assets/js/jquery-ui.min';
import Mixins from './mixins';

Vue.use(Vuex);
Vue.use(VueCarousel);
Vue.mixin(Mixins);

/** Global Vue Store
 *
 *  @type {Boolean} debug
 *    Defines whether the app is in debug mode
 *
 *  @type {Boolean} hasMainView
 *    Defines whether the app main component has loaded correctly
 *
 *  @type {Boolean} hasBack
 *    Defines whether the current rendered template supports the makeBackCall function,
 *    and displays relative button accordingly
 *
 *  @type {Boolean} hasBannerHelp
 *    Defines whether the current rendered template needs the bannerHelp component,
 *    and displays it accordingly
 *
 *  @type {Boolean} hasAdvertisment
 *    Defines whether the current rendered template needs the advertisment component
 *    and displays it accordingly
 *
 *  @type {Boolean} hasBack
 *    Defines whether the current rendered template supports the makeBackCall function,
 *    and displays relative button accordingly
 *
 *  @type {Object} advertismentConfig
 *    Contains all data relative to currently loaded advertisment component
 *
 *    @type {Object} image
 *      Object containing info about the image block in the advertisment.
 *      Takes priority over the products block
 *
 *    @type {Array} products
 *      Object containing info about the products block in the advertisment
 *
 *  @type {Boolean} isNavOpen
 *    Defines whether the navigation menu is displayed
 *
 *  @type {Boolean} isApplicationLoading
 *    Defines whether the application is loading data during an ajax call,
 *    and displays loading spinner accordingly
 *
 *  @type {Boolean} hasAnimations
 *    Defines whether the current component should be animated
 *
 *  @type {Object} routes
 *    Contains the endpoints set up in the global ENV variable
 *
 *  @type {Array} templates
 *    Contains all the templates that can be rendered, with relative variant and component
 *
 *  @type {Object} tempConfigObj
 *    Contains the data of the template to be rendered
 *
 *  @type {Boolean} productListing
 *    Contains the data of the e-commerce product listing to be rendered
 */

const store = new Vuex.Store({
  debug: true,
  state: {
    hasMainView: false,
    hasBack: false,
    hasBannerHelp: false,
    hasAdvertisment: false,
    advertismentConfig: {
    },
    isNavOpen: false,
    isApplicationLoading: false,
    hasAnimations: true,
    routes: WIZARD.ajaxRoutes,
    templates: [
      {name: 'start_stnd_a',              component: 'start-standard'},
      {name: 'start_stnd_b',              component: 'start-standard'},
      {name: 'start_stnd_c',              component: 'start-standard'},
      {name: 'question_stnd_a',           component: 'question-standard'},
      {name: 'question_stnd_b',           component: 'question-standard'},
      {name: 'question_stnd_c',           component: 'question-standard'},
      {name: 'question_system',           component: 'question-standard'},
      {name: 'question_room',             component: 'question-standard'},
      {name: 'question_temperature',      component: 'question-standard'},
      {name: 'question_split',            component: 'question-standard'},
      {name: 'question_split_alt',        component: 'question-standard'},
      {name: 'question_recap',            component: 'question-standard'},
      {name: 'question_info',             component: 'question-standard'},
      {name: 'question_range',            component: 'range-standard'},
      {name: 'question_simroom',          component: 'range-standard'},
      {name: 'question_range_alt',        component: 'range-standard'},
      {name: 'question_area',             component: 'input-area'},
      {name: 'question_cap',              component: 'input-cap'},
      {name: 'question_power',            component: 'input-power'},
      {name: 'alert_stnd',                component: 'alert-standard'},
      {name: 'summary_system',            component: 'summary-system'},
      {name: 'summary_room',              component: 'summary-room'},
      {name: 'summary_room_single',       component: 'summary-room'},
      {name: 'summary_split',             component: 'summary-engine'},
      {name: 'summary_power',             component: 'summary-power'},
      {name: 'help_stnd_a',               component: 'help-standard'},
      {name: 'help_stnd_b',               component: 'help-standard'},
      {name: 'help_stnd_c',               component: 'help-alternate'},
      {name: 'loop_split',                component: 'summary-split'},
      {name: 'loop_rooms',                component: 'loop-standard'},
      {name: 'product_listing',           component: 'product-listing'},
      {name: 'product_cart',              component: 'product-cart'},
      {name: 'question_suggested_split',  component: 'view-question'}
    ],
    tempConfigObj: {},
    productListing: []
  }
});

new Vue({
    el: '#root',
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js